import { useState } from 'react'
import styled, { css, keyframes } from 'styled-components'
import OrgSwitcher from '../OrgSwitcher/OrgSwitcher'
import useAuth from '../../hooks/useAuth'

const blink = keyframes`
  0% { background: var(--color-text-secondary); }
  50% { background: var(--color-primary); }
  100% { background: var(--color-text-secondary); }
`

const Box = styled.div`
  min-width: 200px;
  background-color: var(--color-bg-sidebar);
  border-radius: 4px;
  text-transform: capitalize;
  font-weight: bold;
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: var(--color-primary);
  }
`

const Col = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 10px;
`

const Label = styled.p`
  color: var(--color-text-secondary);
  font-size: 10px;
  margin-bottom: 2px;

  @media only screen and (max-width: 920px) {
    font-size: 12px;
  }
`

const Org = styled.h1`
  color: var(--color-text-primary);
  font-size: 12px;

  ${p => p.isMenuOpen && css`
    &::after {
      content: '';
      display: inline-block;
      background-color: var(--color-text-secondary);
      margin-left: 2px;
      animation: ${blink} 1.2s infinite;
      width: 2px;
      height: 9px;
    }
  `}

  @media only screen and (max-width: 920px) {
    font-size: 14px;
  }
`

const Organization = () => {
  const [selecting, setSelecting] = useState('')
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { selectedOrg } = useAuth()

  return (
    <Box>
      <Col>
        <Label>Currently Viewing</Label>
        <Org isMenuOpen={isMenuOpen}>{selecting || selectedOrg.label}</Org>
      </Col>
      <OrgSwitcher
        handleValueChange={value => setSelecting(value)}
        setIsMenuOpen={setIsMenuOpen}
      />
    </Box>
  )
}

export default Organization
